"use client";

import { createContext } from "react";

/** A streamed board owns its title; task labels remain available as event metadata. */
export const WhiteboardHeadingContext = createContext({ showTitle: true, showSectionLabels: true });
